import { Component, Input } from '@angular/core';

@Component({
  selector: 'om-check-render',
  templateUrl: './om-check-render.component.html',
  styleUrls: ['./om-check-render.component.scss']
})
export class OmCheckRenderComponent {
  @Input() id: string;
  counter = 0;
  constructor() { }
  check() {
    this.counter++;
    // console.log(`rendering:[${this.id}] ${this.counter}`);
    return "";
  }
}
